var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useLayout } from "./layout";
import { Slot } from "@/utils/types/layout";
import { useEvents } from "@/hooks/events";
import { WidgetTopic } from "@/utils/types/widgets";
import { useLogger } from "@/utils/loggerService";
export function usePopup() {
    var _this = this;
    var events = useEvents().eventBus;
    var layout = useLayout();
    var logger = useLogger().logger;
    /**
     * Display popup
     * @param params
     * @returns
     */
    var showPopup = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var _a, widget, events;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, layout.addWidget(__assign(__assign({}, params), { slot: params.slot || Slot.MODAL }))];
                case 1:
                    _a = _b.sent(), widget = _a.widget, events = _a.events;
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            logger.debug("Attente de la r\u00E9ponse du widget: ".concat(WidgetTopic.WIDGET_CLOSE, "/").concat(widget.id), widget);
                            events.once("".concat(WidgetTopic.WIDGET_CLOSE, "/").concat(widget.id), function (returnValue) {
                                logger.debug("[POPUP] - WIDGET_CLOSE re\u00E7u", returnValue);
                                resolve(returnValue);
                            });
                        })];
            }
        });
    }); };
    /**
     * Close popup
     * @param id
     * @param result
     */
    var closePopup = function (id, reason, slot) {
        if (slot === void 0) { slot = [
            Slot.DRAWER_EAST,
            Slot.DRAWER_WEST,
            Slot.DRAWER_NORTH,
            Slot.DRAWER_SOUTH,
            Slot.MODAL,
        ]; }
        return __awaiter(_this, void 0, void 0, function () {
            var widget;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, layout.findWidgets({
                            id: id,
                            slot: slot,
                        })];
                    case 1:
                        widget = (_a.sent())[0];
                        logger.debug("[POPUP] - Envoi WIDGET_REQUEST_CLOSE", widget);
                        events.trigger("".concat(WidgetTopic.WIDGET_REQUEST_CLOSE), {
                            widget: widget,
                            reason: reason,
                        });
                        events.trigger("".concat(WidgetTopic.WIDGET_REQUEST_CLOSE, "/").concat(id), {
                            widget: widget,
                            reason: reason,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return { showPopup: showPopup, closePopup: closePopup };
}
